// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CaseOrderedRelationshipModel } from './caseOrderedRelationshipModel.js';
import type { RoleType } from './roleType.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class CasePayorRelationshipModel {
    'roleType'?: RoleType;
    'caseRelations'?: Array<CaseOrderedRelationshipModel>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CasePayorRelationshipModel>> = [
        {
            "name":     "roleType",
            "baseName": "roleType",
            "type":     "RoleType"
        },
        {
            "name":     "caseRelations",
            "baseName": "caseRelations",
            "type":     "Array<CaseOrderedRelationshipModel>"
        },
    ];

    static getAttributeTypeMap() {
        return CasePayorRelationshipModel.attributeTypeMap;
    }
}
